import React, { useState, useEffect } from "react";
import "./App.css";
import axios from "axios";
// import jwt from "jsonwebtoken";
import EmpReg from "./component/PreComps/EmployeeReg/EmpReg";

import Login from "./component/PreComps/Includes/Login.jsx";
// import SignUp from "./component/PreComps/Includes/SignUp.jsx";
// import Temp from "./component/PreComps/Includes/Temp.jsx";
// import NotFound404 from "./component/PreComps/Includes/NotFound404.jsx";
import DashboardAdmin from "./component/admin/DashboardAdmin.jsx";
import DashboardHR from "./component/hr/DashboardHR.jsx";
import DashboardEmployee from "./component/employee/Dashboard/DashboardEmployee.jsx";
import HODEmployee from "./component/hod/Dashboard/DashboardHOD.jsx";
import CEOEmployee from "./component/ceo/Dashboard/DashboardCEO.jsx";
import { Switch } from "react-router";

// import RQ from "./component/NewComponents/RQ"

import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import { FunctContext } from "./shared/context/universal-function";
import { UniversalFunction } from "./shared/hooks/univ-func";
import { useHistory } from "react-router-dom";

function App() {
  const {
    token,
    userId,
    AccountType,
    Name,
    Email,
    logoutTime,
    login,
    logout,
    Path,
    setPath,
    cl,
    GetDate,
  } = UniversalFunction();

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [pass, setPass] = useState(true);
  const [isLogin, setIsLogin] = useState(false);
  const [firstTimeAlert, setFirstTimeAlert] = useState(true);
  const history = useHistory();

  //   const params = useParams();

  // useEffect(() => {
  //   console.log("route has been changed", params);
  // }, [params]);
  useEffect(() => {
    setIsLogin(localStorage.getItem("isLogin") === "true");
    const StoredisLogin = localStorage.getItem("isLogin");
    const storedToken = localStorage.getItem("token");

    if (!!StoredisLogin && !!storedToken) {
      setIsLogin(true);
      setData({
        _id: localStorage.getItem("_id"),
        Account: [localStorage.getItem("Account")],
        FirstName: localStorage.getItem("FName"),
        LastName: localStorage.getItem("LName"),
        Email: localStorage.getItem("Email"),
        EmpRole: [localStorage.getItem("EmpRole")],
        token: localStorage.getItem("token"),
        department: localStorage.getItem("department"),
      });
      setIsLogin(localStorage.getItem("isLogin") === "true");
    }
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    // console.log("id", event.target[0].value);
    setPass(true);
    setLoading(true);
    llogin(event.target[0].value, event.target[1].value);
    event.target.reset();
  };
  const handleLogout = (event) => {
    // console.log("logout");
    setData({});
    setLoading(false);
    setPass(true);
    setIsLogin(false);
    setFirstTimeAlert(true);
    localStorage.clear();
  };
  const llogin = (id, pass) => {
    // history.push('new/path/here/');

    // history.push('/page');
    // History.push('/page');
    // context.history.push('/path');

    //email=admin@fenil.com&password=admin

    let bodyLogin = {
      email: id,
      password: pass,
    };
    // let bodyLogin ="email="+id+"&password="+pass;
    // {Email: id, Password: pass}

    axios
      .post(
        "https://almawridems.javedahmadghamidi.com/api/ems/login",
        bodyLogin
      )
      .then((res) => {
        // console.log(decodedData.Account);
        // console.log(res.data);
        var decodedData = res.data;

        if (
          (res === undefined ||
            res === null ||
            decodedData.Account[0] === undefined ||
            decodedData.Account[0] === null) &&
          !(
            decodedData.Account[0] === "admin" ||
            decodedData.Account[0] === "hr" ||
            decodedData.Account[0] === "hod" ||
            decodedData.Account[0] === "ceo" ||
            decodedData.Account[0] === "emp"
          )
        ) {
          setPass(false);
          setLoading(false);
          alert("Network or Server Problem");
        } else {
          localStorage.setItem("_id", decodedData["_id"]);
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("department", res.data.department);
          localStorage.setItem("FName", decodedData["FirstName"]);
          localStorage.setItem("LName", decodedData["LastName"]);
          localStorage.setItem("Email", decodedData["Email"]);
          localStorage.setItem("Account", decodedData.Account[0]);
          localStorage.setItem("isLogin", true);

          setData(decodedData);
          setPass(true);
          setLoading(false);
          setIsLogin(true);

          if (decodedData.Account[0] === "admin") {
            history.push("/admin/role");
          }
          if (decodedData.Account[0] === "hr") {
            history.push("/hr/employee");
          }
          if (decodedData.Account[0] === "emp") {
            history.push("/employee/" + decodedData._id + "/personal-info");
          }
          if (decodedData.Account[0] === "ceo") {
            history.push("/ceo/" + decodedData._id + "/personal-info");
          }
          if (decodedData.Account[0] === "hod") {
            history.push("/hod/" + decodedData._id + "/personal-info");
          }
        }

        //  console.log(decodedData);
        //  console.log(`decodedData.toString()==="false" `,decodedData.toString()==="false" );

        //  if(decodedData.toString()==="false")

        //  { console.log("1");
        //  setState({ pass: false })
        //  setState({ loading: false }); ;

        // }else{
        //   console.log("2");
        //   setState({ pass: true });
        //  setState({ loading: false });
        //  setState({ data: decodedData});
        //  setState({ isLogin: true });

        // }
      })
      .catch((err) => {
        console.log(err);
        setPass(false);
        setLoading(false);
      });
  };

  return (
    <FunctContext.Provider
      value={{
        Path: Path,
        setPath: setPath,
        cl: cl,
        GetDate: GetDate,
        isLoggedIn: !!token,
        token: token,
        userId: userId,
        Name: Name,
        Email: Email,
        AccountType: AccountType,
        logoutTime: logoutTime,
        login: login,
        logout: logout,
      }}>
      <Router>
        <Switch>
          <Route
            exact
            path="/login"
            render={(props) =>
              !!data.Account && data.Account[0] === "admin" ? (
                <Redirect to="/admin" />
              ) : !!data.Account && data.Account[0] === "hr" ? (
                <Redirect to="/hr" />
              ) : !!data.Account && data.Account[0] === "emp" ? (
                <Redirect to="/employee" />
              ) : !!data.Account && data.Account[0] === "hod" ? (
                <Redirect to="/hod" />
              ) : !!data.Account && data.Account[0] === "ceo" ? (
                <Redirect to="/ceo" />
              ) : (
                <Login onSubmit={handleSubmit} loading={loading} pass={pass} />
              )
            }
          />
          <Route exact path="/SignUp" render={(props) => <EmpReg />} />
          <Route
            // exact
            path="/admin"
            render={(props) =>
              !!data.Account && data.Account[0] === "admin" ? (
                <DashboardAdmin data={data} onLogout={handleLogout} />
              ) : (
                <Redirect to="/login" />
              )
            }
          />
          <Route
            // exact
            path="/hr"
            render={(props) =>
              !!data.Account && data.Account[0] === "hr" ? (
                <DashboardHR data={data} onLogout={handleLogout} />
              ) : (
                <Redirect to="/login" />
              )
            }
          />
          <Route
            // exact
            path="/employee"
            render={(props) =>
              !!data.Account && data.Account[0] === "emp" ? (
                <DashboardEmployee data={data} onLogout={handleLogout} />
              ) : (
                <Redirect to="/login" />
              )
            }
          />
          <Route
            // exact
            path="/hod"
            render={(props) =>
              !!data.Account && data.Account[0] === "hod" ? (
                <HODEmployee data={data} onLogout={handleLogout} />
              ) : (
                <Redirect to="/login" />
              )
            }
          />
          <Route
            // exact
            path="/ceo"
            render={(props) =>
              !!data.Account && data.Account[0] === "ceo" ? (
                <CEOEmployee data={data} onLogout={handleLogout} />
              ) : (
                <Redirect to="/login" />
              )
            }
          />
          <Redirect to="/login" />
        </Switch>
      </Router>
    </FunctContext.Provider>
  );
}

export default App;
